// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import DrivingTestService from '@services/driving-test'

export const getETestSections = createAsyncThunk('drivingTestSections/getETestSections', async (params, { rejectWithValue }) => {
  try {
    const response = await DrivingTestService.getETestSections(params)

    return { params, data: response.data, totalPages: response.meta.itemCount }
  } catch (err) {
    return rejectWithValue(err.response.data)
  }
})

export const getETestSection = createAsyncThunk('drivingTestSections/getETestSection', async (id, { rejectWithValue }) => {
  try {
    const response = await DrivingTestService.getETestSection(id)
    return response
  } catch (err) {
    return rejectWithValue(err.response.data)
  }
})

export const addETestSection = createAsyncThunk('drivingTestSections/addETestSection', async (data, { rejectWithValue }) => {
  try {
    const response = await DrivingTestService.postETestSection(data)
    return response
  } catch (err) {
    return rejectWithValue(err.response.data)
  }
})

export const updateETestSection = createAsyncThunk('drivingTestSections/updateETestSection', async (data, { rejectWithValue }) => {
  console.log("Updating E-Test Section with data:", data)
  try {
    const { id } = data
    const response = await DrivingTestService.updateETestSection(id, data)

    return response
  } catch (err) {
    console.log("this one", err)
    return rejectWithValue(err)
  }
})

const DrivingTestSections = createSlice({
  name: 'drivingTestSections',
  initialState: {
    data: [],
    total: 1,
    params: {},
    allData: [],
    loading: true,
    errors: null,
    selectedETestSection: null
  },
  reducers: {},

  extraReducers(builder) {
    builder
      .addCase(getETestSections.fulfilled, (state, action) => {
        state.data = action.payload.data
        state.params = action.payload.params
        state.total = action.payload.totalPages
        state.selectedETestSection = null
      })
      .addCase(getETestSection.pending, (state) => {
        state.selectedETestSection = null
        state.loading = true
      })
      .addCase(getETestSection.fulfilled, (state, action) => {
        state.loading = false
        state.errors = null
        state.selectedETestSection = action.payload
      })
      .addCase(getETestSection.rejected, (state, action) => {
        state.selectedETestSection = null
        state.errors = action.payload
        state.loading = false
      })
  }
})

// export const getAllOfficeLocation = (state) => state.officeLocations.office_location
// export const selectOfficeLocationById = (state, id) => state.officeLocations.data.find((office_location) => office_location.id === id)

export default DrivingTestSections.reducer
